<template>
    <div class="manager-list">
        
        <div class="input-group">
            <div class="input-group-addon">
                <span class="glyphicon glyphicon-search"></span>
            </div>
            <input type="text" class="form-control" placeholder="搜尋 人名 或 Slack id" v-model="searchText">
        </div>
        <table id="users-tabel" class="table">
            <thead>
                <tr>
                    <th>帳號</th>
                    <th>Email</th>
                    <th>Slack id</th>
                    <th>休假紀錄</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="user in users" :key="user.id" v-show="user.name.indexOf(searchText) >= 0 || user.slack_id.indexOf(searchText) >= 0">
                    <td>
                        {{user.name}}
                    </td>
                    <td>
                        {{user.email}}
                    </td>
                    <td>
                        {{user.slack_id}}
                    </td>
                    <td>
                        <button class="btn btn-link" @click="handleViewBtnClick(user)">
                            <span class="glyphicon glyphicon-info-sign"></span>
                            查看
                        </button>

                    </td>
                </tr>
            </tbody>
        </table>
        <history-modal :user-name="modalUserName" :user-uuid="modalUuid" ref="modal"></history-modal>
    </div>
</template>

<script>
export default {
    components: {
        'history-modal': require('./history-modal.vue').default
    },

    props: {
        users: []
    },

    data () {
        return {
            modalUuid: '',
            modalUserName: '',
            searchText: ''
        }
    },

    methods: {
        handleViewBtnClick: function (user) {
            this.modalUuid = user.uuid;
            this.modalUserName = user.name;
            $(this.$ref.modal).modal();
        }
    },

    mounted() {
        $(this.$ref.modal).on('hide.bs.modal', (function() {
            this.modalUserName = '';
            this.modalUuid = '';
        }).bind(this));
    }
}
</script>

<style lang="scss" scoped>

</style>
